import type { AddressFragment } from "../../../common/generated-types";

export type AddressFormValue = Pick<
    AddressFragment,
    Exclude<keyof AddressFragment, "country">
> & { countryCode: string };

export enum CheckoutShippingStep {
    Address = "address",
    SelectAddress = "selectAddress",
}
